
ApplicationsController.$inject = ['$scope',  'company', 'ApplicationsFactory', 'AlertingFactory', 
                                   'ConfirmationFactory', 'TopToolbarFactory', '$state', 'applications'];
export function ApplicationsController($scope, company, ApplicationsFactory, AlertingFactory, 
                                       ConfirmationFactory, TopToolbarFactory, $state, applications) {

  $scope.deleteApplication = deleteApplication;


  init();


  function editApplication(applicationId) {
    $state.go('auth.alcmeon.fuse.parameters.edit-application', { applicationId });
  }


  function deleteApplication(application) {
    ConfirmationFactory.materialConfirmDialog('parameters/applications/confirm-deletion')
      .then(() => {
        const index = $scope.applications.indexOf(application);
        ApplicationsFactory.deleteApplication(company.id, application.id)
        .then(() => $scope.applications.splice(index, 1),
              AlertingFactory.httpErrorHandler());    
      });
  }
    

  function createApplication() {
    ApplicationsFactory.createApplication(company.id)
      .then(response => editApplication(response.data.application_id),
            AlertingFactory.httpErrorHandler());
  }


  function init() {
    TopToolbarFactory.setTitleTranslation('parameters/applications/title', $scope);
    TopToolbarFactory.setSecondaryButton('parameters/applications/create', createApplication, $scope);
    $scope.applications = applications;
    $scope.sortColumn = 'createdOn'; // sort by creation date by default
  }

}
